module.exports = __webpack_public_path__ + "d9ac8e8bafe9b8ca2a15b68e8281ac3f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = AqYs
// module chunks = 1